function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#E5E5E5"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-873 -1005C-873 -1006.1 -872.105 -1007 -871 -1007H190C191.105 -1007 192 -1006.1 192 -1005V171C192 172.105 191.105 173 190 173H-871C-872.105 173 -873 172.105 -873 171V-1005Z",
  fill: "#B7B7B7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M-871 -1006H190V-1008H-871V-1006ZM191 -1005V171H193V-1005H191ZM190 172H-871V174H190V172ZM-872 171V-1005H-874V171H-872ZM-871 172C-871.552 172 -872 171.552 -872 171H-874C-874 172.657 -872.657 174 -871 174V172ZM191 171C191 171.552 190.552 172 190 172V174C191.657 174 193 172.657 193 171H191ZM190 -1006C190.552 -1006 191 -1005.55 191 -1005H193C193 -1006.66 191.657 -1008 190 -1008V-1006ZM-871 -1008C-872.657 -1008 -874 -1006.66 -874 -1005H-872C-872 -1005.55 -871.552 -1006 -871 -1006V-1008Z",
  fill: "black",
  fillOpacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 360,
  height: 1000,
  transform: "translate(-332 -917)",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.05368 11.7495C6.93026 11.7495 6.80684 11.7023 6.71283 11.6083C6.52433 11.4198 6.52433 11.1151 6.71283 10.9266L9.26459 8.37483L6.71283 5.82307C6.52433 5.63457 6.52433 5.32988 6.71283 5.14138C6.90133 4.95287 7.20602 4.95287 7.39452 5.14138L10.2871 8.03399C10.4756 8.22249 10.4756 8.52718 10.2871 8.71568L7.39452 11.6083C7.30051 11.7023 7.17709 11.7495 7.05368 11.7495Z",
  fill: "#999999"
});

function SvgIconChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSIjRTVFNUU1Ii8+CjxwYXRoIGQ9Ik0tODczIC0xMDA1Qy04NzMgLTEwMDYuMSAtODcyLjEwNSAtMTAwNyAtODcxIC0xMDA3SDE5MEMxOTEuMTA1IC0xMDA3IDE5MiAtMTAwNi4xIDE5MiAtMTAwNVYxNzFDMTkyIDE3Mi4xMDUgMTkxLjEwNSAxNzMgMTkwIDE3M0gtODcxQy04NzIuMTA1IDE3MyAtODczIDE3Mi4xMDUgLTg3MyAxNzFWLTEwMDVaIiBmaWxsPSIjQjdCN0I3Ii8+CjxwYXRoIGQ9Ik0tODcxIC0xMDA2SDE5MFYtMTAwOEgtODcxVi0xMDA2Wk0xOTEgLTEwMDVWMTcxSDE5M1YtMTAwNUgxOTFaTTE5MCAxNzJILTg3MVYxNzRIMTkwVjE3MlpNLTg3MiAxNzFWLTEwMDVILTg3NFYxNzFILTg3MlpNLTg3MSAxNzJDLTg3MS41NTIgMTcyIC04NzIgMTcxLjU1MiAtODcyIDE3MUgtODc0Qy04NzQgMTcyLjY1NyAtODcyLjY1NyAxNzQgLTg3MSAxNzRWMTcyWk0xOTEgMTcxQzE5MSAxNzEuNTUyIDE5MC41NTIgMTcyIDE5MCAxNzJWMTc0QzE5MS42NTcgMTc0IDE5MyAxNzIuNjU3IDE5MyAxNzFIMTkxWk0xOTAgLTEwMDZDMTkwLjU1MiAtMTAwNiAxOTEgLTEwMDUuNTUgMTkxIC0xMDA1SDE5M0MxOTMgLTEwMDYuNjYgMTkxLjY1NyAtMTAwOCAxOTAgLTEwMDhWLTEwMDZaTS04NzEgLTEwMDhDLTg3Mi42NTcgLTEwMDggLTg3NCAtMTAwNi42NiAtODc0IC0xMDA1SC04NzJDLTg3MiAtMTAwNS41NSAtODcxLjU1MiAtMTAwNiAtODcxIC0xMDA2Vi0xMDA4WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4xIi8+CjxyZWN0IHdpZHRoPSIzNjAiIGhlaWdodD0iMTAwMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMzMiAtOTE3KSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjA1MzY4IDExLjc0OTVDNi45MzAyNiAxMS43NDk1IDYuODA2ODQgMTEuNzAyMyA2LjcxMjgzIDExLjYwODNDNi41MjQzMyAxMS40MTk4IDYuNTI0MzMgMTEuMTE1MSA2LjcxMjgzIDEwLjkyNjZMOS4yNjQ1OSA4LjM3NDgzTDYuNzEyODMgNS44MjMwN0M2LjUyNDMzIDUuNjM0NTcgNi41MjQzMyA1LjMyOTg4IDYuNzEyODMgNS4xNDEzOEM2LjkwMTMzIDQuOTUyODcgNy4yMDYwMiA0Ljk1Mjg3IDcuMzk0NTIgNS4xNDEzOEwxMC4yODcxIDguMDMzOTlDMTAuNDc1NiA4LjIyMjQ5IDEwLjQ3NTYgOC41MjcxOCAxMC4yODcxIDguNzE1NjhMNy4zOTQ1MiAxMS42MDgzQzcuMzAwNTEgMTEuNzAyMyA3LjE3NzA5IDExLjc0OTUgNy4wNTM2OCAxMS43NDk1WiIgZmlsbD0iIzk5OTk5OSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };